module.exports = __webpack_public_path__ + "img/allianz-sigorta.52273805.jpg";